import { useTranslation } from 'react-i18next';

import { appConfig } from '@/modules/app/appConfig';
import { HeaderButtonLink } from '@/modules/theme/components/HeaderButton';

export const SupplierExportButton = ({
  negotiationId,
}: {
  negotiationId?: string;
}) => {
  const { t } = useTranslation('modules/negotiations/NegotiationExportButton');

  return (
    <HeaderButtonLink
      onClick={() => {
        window.open(
          `${appConfig.api.baseUrl}/customer/negotiations/${
            negotiationId ?? ''
          }/supplier_progress.xlsx`
        );
      }}
      to=""
    >
      {t('Export results')}
    </HeaderButtonLink>
  );
};
